import { Component, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  NavController,
  ModalController,
  ToastController,
  Platform,
  IonDatetime,
  IonDatetimeButton,
  LoadingController
} from "@ionic/angular";
import { CategoryModel } from "../../../../providers/categories/categories";
import { LoaderProvider } from "../../../../providers/loader/loader";
import {
  MyPicsListModel,
  PrivateProfile,
  UserProvider
} from "../../../../providers/user/user";
import {
  BackgroundModel,
  SinleValueModel,
  TextValueModel
} from "../../../../providers/value/value";
import { SessionProvider } from "../../../../providers/session/session";
import { ConfigProvider } from "../../../../providers/config/config";
import { NewsProvider, PagerModel } from "../../../../providers/news/news";
import { Device } from "@awesome-cordova-plugins/device/ngx";
import { AppDetectorProvider } from "../../../../providers/detector/detector";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { NavigationService } from "src/providers/navigation/navigation.service";

/**
 * Generated class for the PrivateProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-private-profile",
  templateUrl: "private-profile.html",
  styleUrls:['./private-profile.scss']
})
export class PrivateProfilePage {
  @ViewChild("uploadButton")
  uploadButton: any;
  @ViewChild('datePicker', { static: false }) datePicker!: IonDatetimeButton;
  isDatePickerOpen = false;
  datePopoverEvent: any = null;

  profileBackup: PrivateProfile;
  profile: PrivateProfile;
  titles: SinleValueModel[] = [];
  types: SinleValueModel[] = [];
  categories: CategoryModel[] = [];
  photos: MyPicsListModel[] = [];
  countries: TextValueModel[] = [];
  backgrounds: BackgroundModel[] = [];
  birthDay: string;
  activeTop: string = "preview";

  isPostbonnApp: boolean = false;
  isVivawestApp: boolean = false;
  isEmployeeDHL: boolean = false;
  readOnly: boolean = false;
  private toast = null;

  constructor(
    public navCtrl: NavController,
    public router:Router,
    public location:Location,
    public translate: TranslateService,
    public userService: UserProvider,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private sessionService: SessionProvider,
    private toastCtrl: ToastController,
    private config: ConfigProvider,
    private newsService: NewsProvider,
    private device: Device,
    public appDetector: AppDetectorProvider,
    private platform: Platform,
    private navService:NavigationService
  ) {
    this.appVerification();
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};

    this.profileBackup = state['data'].profile;
    this.profile = JSON.parse(JSON.stringify(this.profileBackup));
    if (this.profile.birthday && this.profile.birthday !== -1) {
      this.birthDay = this.profile.birthday == 0 ? "" : new Date(this.profile.birthday).toISOString();
    }
    this.isEmployeeDHL = (this.profile.clubName.includes("Deutsche Post DHL Group")) ? true : false;
    this.titles = state['data'].titles;
    this.types = state['data'].types;
    this.categories = state['data'].categories;
    this.photos = state['data'].photos;
    this.countries = state['data'].countries;
    this.backgrounds = state['data'].backgrounds;
    this.readOnly = state['data'].readOnly;
    this.profile.status = this.profile.status.length > 0 ? this.profile.status : this.types[0].value;
  }

  async appVerification() {
    let name: string = (await this.config.config).appId;

    this.isPostbonnApp = name.toLocaleLowerCase().includes("postbonn");
    this.isVivawestApp = name.toLocaleLowerCase().includes("vivawest");

    console.log('isVivawestApp: ' + this.isVivawestApp);
  }

  ionViewDidEnter() {
    console.log("ionViewDidEnter PrivateProfilePage");
  }

  employeeCheckboxEvent() {
    this.profile.clubName = (this.isEmployeeDHL) ? "Deutsche Post DHL Group" : "";
    this.save(false);
    if (this.isEmployeeDHL) this.fireMessage(this.translate.instant('PRIVATE_DHL_POLICY'));
  }

  async fireMessage(message) {
    let toast = await this.toastCtrl.create({
      message: message,
      duration: 7000,
      position: "top"
    })
    toast.present();
  }

  // openSportarts() {
  // let sportartModal = this.modalCtrl.create(MeSettingsSportartsPage, {
  //   data: { categories: this.categories, picked: this.profile.sportTypesVec }
  // });
  // sportartModal.present();

  // (this.app.getRootNav() as NavController).push(MeSettingsSportartsPage, { data: { categories: this.categories, picked: this.profile.sportTypesVec } })
  // }

  checkForm() {
    let hasError = false;
    let text = "";

    if (
      !this.profile.forName ||
      this.profile.forName.length === 0 ||
      !this.profile.surName ||
      this.profile.surName.length === 0
    ) {
      hasError = true;
      text +=
        this.translate.instant("PRIVATEPROFILE_FILL_THE_FORM_FIRST") + "\n";
    }
    /*if (!this.profile.anrede || this.profile.anrede.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_TITLE") }) + "\n";
    }
    if (!this.profile.city || this.profile.city.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_CITY") }) + "\n";
    }
    if (!this.profile.sportTypesVec || this.profile.sportTypesVec.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_AT_LEAST_X_Y_IS_REQUIRED", { count: 1, name: this.translate.instant("PRIVATEPROFILE_MY_SPORTART") }) + "\n";
    }
    if (!this.profile.status || this.profile.status.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_PROFILE_TYPE") }) + "\n";
    }
    if (!this.profile.zip || this.profile.zip.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_ZIP") }) + "\n";
    }
    if (!this.profile.forName || this.profile.forName.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_FIRST_NAME") }) + "\n";
    }
    if (!this.profile.surName || this.profile.surName.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_LAST_NAME") }) + "\n";
    }
*/
    if (hasError) {
      this.toastCtrl
        .create({
          message: text,
          duration: 6000,
          buttons:[{text:'OK', role:'cancel'}]
        }).then(toast=>toast.present());
    }

    return !hasError;
  }

  async save(exitTrigger: boolean = true) {
    console.log('save');
    let loader = await this.loadingCtrl.create({
      message: this.translate.instant("GLOBAL_LOADING")
    });
    loader.present();

    if (this.checkForm()) {
      if (this.birthDay) {
        this.profile.birthday = new Date(this.birthDay).getTime();
      } else {
        this.profile.birthday = -1;
      }

      this.profile.phoneType = this.device.platform + " " + this.device.version;

      this.userService.updateProfile(this.profile);

      // if (prof && typeof prof != undefined) {
      this.sessionService.profile.id = this.profile.id;
      this.sessionService.profile.area = this.profile.area;
      this.sessionService.profile.anrede = this.profile.anrede;
      if (this.profile.birthday && this.profile.birthday !== -1)
        this.sessionService.profile.birthday = this.profile.birthday;
      this.sessionService.profile.city = this.profile.city;
      this.sessionService.profile.country = this.profile.country;
      this.sessionService.profile.profilePicLink = this.profile.profilePicLink;
      this.sessionService.profile.status = this.profile.status;
      this.sessionService.profile.themeName = this.profile.themeName;
      this.sessionService.profile.zip = this.profile.zip;
      this.sessionService.profile.forName = this.profile.forName;
      this.sessionService.profile.surName = this.profile.surName;
      this.sessionService.profile.clubName = this.profile.clubName;
      this.sessionService.profile.phoneType = this.profile.phoneType;


      let it = this.photos.find(
        x => x.imageLink === this.profile.profilePicLink
      );
      if (it && it.id) {
        let succ = await this.userService.updateProfilePicture(it.id);
        if (succ) {
          if (!it)
            this.sessionService.profile.profilePicLink = this.profile.profilePicLink;
        }
      }
      if (exitTrigger) {
        if (window.history.length > 1) {
          this.location.back();
          loader.dismiss();
        } else {
          this.location.back();
          loader.dismiss();
        }
      } else {
        loader.dismiss();
      }
    } else {
      loader.dismiss();
    }
  }
  getCover(cover: string) {
    if(this.profile.themeName ==='spooorts.de') this.profile.themeName = 'blue-curtain';
    return (cover) ? this.backgrounds.find(x => x.value === cover).img : "";
  }

  get getInitialSlide() {
    let theme = this.backgrounds.findIndex(x => x.value == this.profile.themeName);
    return theme == -1 ? 4 : theme;
  }
  chooseCover() {
    this.activeTop = "cover";
  }
  presentToast(message, position, cssclass) {
    if (this.toast) {
      this.toast.dismiss();
      this.toast = null;
    }
    this.toast = this.toastCtrl.create({
      message: message,
      cssClass: cssclass,
      position: position,
      duration: 10000
    });
    this.toast.present();
  }
  uploadPhoto() {
    const allowed = localStorage.getItem('isPhotoUploadAllowedKey')
		if (!allowed && this.platform.is('android') ){
      this.presentToast(this.translate.instant("IMAGE_DENIED"),'bottom', "permission-sheet");
    }else{
      this.navCtrl.navigateForward('/settings/private-profile-photos',{state:{ data: { pictures: this.photos, profile: this.profile }}})
      // (this.app.getRootNav() as NavController).push(PrivateProfilePhotosPage, {
      //   data: { pictures: this.photos, profile: this.profile }
      // });
    }
    /*
    this.activeTop = "photo";
    setTimeout(() => {
      this.createFileInput();
    });
    */
  }
  presentDatePicker(ev: Event) {
    this.datePopoverEvent = ev;
    this.isDatePickerOpen = true;
  }

  selectBg(bg: BackgroundModel) {
    this.profile.themeName = bg.value;
    this.activeTop = "preview";
  }

}
